export default __webpack_public_path__ + "static/media/Vijay Infra.56666191.png";